import { Stack } from '@mui/material';
import { useCallback, useEffect, useMemo, useState } from 'react';
import { getWorkspacePhoneCreditLogs, IWorkspacePhoneCreditLog } from 'wisestep-api';
import { WsDataTable, WsPagination, WsTypography, WsTypoVariants } from 'wisestep-base';

import { useWorkspaceContext } from '../../../context';
import { failed } from '../../../utils/NotificationMessages';
import { useNotificationStore } from '../../../utils/NotificationStore';

const CommunicationLogs = () => {
  const [logs, setLogs] = useState<IWorkspacePhoneCreditLog[]>([]);

  const [page, setPage] = useState<number>(0);

  const [totalLogs, setTotalLogs] = useState<number>(0);

  const [totalPages, setTotalPages] = useState<number>(0);

  const workspaceId = useWorkspaceContext().id;

  const setNotification = useNotificationStore((state) => state.setNotification);

  const columns = useMemo(
    () => [
      {
        Header: 'ID',
        accessor: 'id',
      },
      {
        Header: 'To',
        accessor: 'to',
      },
      {
        Header: 'From',
        accessor: 'from',
      },
      {
        Header: 'Credits',
        accessor: 'credits',
      },
      {
        Header: 'Direction',
        accessor: 'direction',
      },
      {
        Header: 'Recruiter',
        accessor: 'recruiter',
      },
      {
        Header: 'Time',
        accessor: 'time',
      },
    ],
    []
  );

  const data = useMemo(
    () =>
      logs?.map((log) => ({
        id: log?.smsId,
        to: log?.toNumber,
        from: log?.fromNumber,
        credits: log?.credit,
        direction: log?.isOutbound ? 'OUTBOUND' : 'INBOUND',
        recruiter: log?.recruiterId,
        time: new Date(log?.createdAt).toDateString(),
      })) ?? [],
    [logs]
  );

  const getLogs = useCallback(
    async (page = 0) => {
      try {
        const response = await getWorkspacePhoneCreditLogs(page, 50, workspaceId ?? '');
        response.data.logs.map((log) => setLogs((prev) => [...prev, log]));
        setTotalLogs(parseInt(response.data.totalItems));
        setTotalPages(parseInt(response.data.totalPages));
      } catch (err: any) {
        setNotification(failed(err.message));
      }
    },
    [setNotification, workspaceId]
  );

  const changePage = (ev, newPage) => {
    setPage(newPage);
    getLogs(newPage);
  };

  useEffect(() => {
    getLogs();
  }, [getLogs]);

  return (
    <Stack spacing={3}>
      <Stack direction="row" justifyContent="space-between" alignItems="center">
        <WsTypography bold={true} variant={WsTypoVariants.SUB_TITLE}>
          {`${page * 50 + 1} to ${
            totalLogs > (page + 1) * 50 ? (page + 1) * 50 : totalLogs
          } of ${totalLogs}`}
        </WsTypography>
        <WsPagination count={totalPages} onChange={changePage} />
      </Stack>
      <WsDataTable columns={columns} data={data ?? []} boldItems={['id']} />
    </Stack>
  );
};

export default CommunicationLogs;
